
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { UserPlus } from "lucide-react";

interface AddUserFormProps {
  onAddUser: (username: string, password: string, initialCredits: number) => void;
}

export function AddUserForm({ onAddUser }: AddUserFormProps) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [initialCredits, setInitialCredits] = useState(50);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onAddUser(username, password, initialCredits);
    // Reset form
    setUsername("");
    setPassword("");
    setInitialCredits(50);
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div className="space-y-2">
        <Label htmlFor="username">Όνομα χρήστη</Label>
        <Input 
          id="username" 
          value={username} 
          onChange={(e) => setUsername(e.target.value)} 
          required 
          placeholder="π.χ. user1"
        />
      </div>
      
      <div className="space-y-2">
        <Label htmlFor="password">Κωδικός</Label>
        <Input 
          id="password" 
          type="password" 
          value={password} 
          onChange={(e) => setPassword(e.target.value)} 
          required 
          placeholder="Κωδικός χρήστη"
        />
      </div>
      
      <div className="space-y-2">
        <Label htmlFor="initialCredits">Αρχικά Credits</Label>
        <Input 
          id="initialCredits" 
          type="number" 
          min={0}
          value={initialCredits} 
          onChange={(e) => setInitialCredits(parseInt(e.target.value) || 0)} 
          required 
        />
      </div>
      
      <Button 
        type="submit"
        className="w-full"
        disabled={!username || !password}
      >
        <UserPlus className="h-4 w-4 mr-2" />
        Προσθήκη Χρήστη
      </Button>
    </form>
  );
}
